// start:ng42.barrel
import   './report-service.service';
import   './components';
import   './directives';
// end:ng42.barrel

